import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '@angular/material';
import {BrowserModule} from '@angular/platform-browser';
import {DomSanitizer} from '@angular/platform-browser';
import {AppRoutingModule} from 'app/app-routing.module';
import {SharedModule} from 'app/shared/shared.module';

import {AccordionModule} from 'primeng/primeng';
import {EntitySurveysComponent} from 'app/entities/surveys/entity-surveys.component';
import {SurveyListComponent} from 'app/entities/surveys/surveylist/survey-list.component';
import {SurveyDetailsComponent} from 'app/entities/surveys/surveyDetails/survey-details.component';
import {EntitySurveysService} from 'app/entities/surveys/entity-surveys.service';

@NgModule({
  declarations: [
    EntitySurveysComponent,
    SurveyListComponent,
    SurveyDetailsComponent,
  ],
  imports: [
    MaterialModule.forRoot(),
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    FlexLayoutModule,
    SharedModule,
    AppRoutingModule,
    AccordionModule,
  ],
  exports: [
    EntitySurveysComponent,
    SurveyDetailsComponent
  ],
  entryComponents: [
  ],
  providers: [
    EntitySurveysService
  ]
})

/**
 * Main module for the entity surveys management.
 *
 * @author raj.sharma@vernuso.com (Raj Sharma)
 */
export class EntitySurveysModule {
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/entity-surveys.module.ts